import { initializeFormFields } from './js/form-fields.js';
import { initializeSubformAsArray } from './js/subform-as-array.js';
import { defineMapEvents } from './js/map.js';

import './css/flags.scss';
import './css/form.scss';
import './css/subforms.scss';
import './css/translation.scss';

export function form() {
  $(function () {
    initializeFormFields();
    initializeSubformAsArray();
    defineMapEvents();

    // Display Form
    $('.table-form-row').removeClass('invisible');
  });
}
